import React from "react";
import PropTypes from "prop-types";
import { Container, Row, Col } from "shards-react";
import {
  VictoryBar,
  VictoryChart,
  VictoryAxis,
  VictoryTheme,
  VictoryStack
} from "victory";
import PageTitle from "./../components/common/PageTitle";
import SmallStats from "./../components/common/SmallStats";
import UsersOverview from "./../components/blog/UsersOverview";
import UsersByDevice from "./../components/blog/UsersByDevice";
import NewDraft from "./../components/blog/NewDraft";
import Discussions from "./../components/blog/Discussions";
import TopReferrals from "./../components/common/TopReferrals";

const data2012 = [
  { quarter: 1, earnings: 13000 },
  { quarter: 2, earnings: 16500 },
  { quarter: 3, earnings: 14250 },
  { quarter: 4, earnings: 19000 }
];

const data2013 = [
  { quarter: 1, earnings: 15000 },
  { quarter: 2, earnings: 12500 },
  { quarter: 3, earnings: 19500 },
  { quarter: 4, earnings: 13000 }
];

const data2014 = [
  { quarter: 1, earnings: 11500 },
  { quarter: 2, earnings: 13250 },
  { quarter: 3, earnings: 20000 },
  { quarter: 4, earnings: 15500 }
];

const data2015 = [
  { quarter: 1, earnings: 18000 },
  { quarter: 2, earnings: 13250 },
  { quarter: 3, earnings: 15000 },
  { quarter: 4, earnings: 12000 }
];

class BlogOverview extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      UserisAdmin: false,
      smallStats: [
        {
          label: "Posts",
          value: "2,390",
          percentage: "4.7%",
          increase: true,
          chartLabels: [null, null, null, null, null, null, null],
          attrs: { md: "6", sm: "6" },
          datasets: [
            {
              label: "Today",
              fill: "start",
              borderWidth: 1.5,
              backgroundColor: "rgba(0, 184, 216, 0.1)",
              borderColor: "rgb(0, 184, 216)",
              data: [1, 2, 1, 3, 5, 4, 7]
            }
          ]
        },
        {
          label: "Pages",
          value: "182",
          percentage: "12.4",
          increase: true,
          chartLabels: [null, null, null, null, null, null, null],
          attrs: { md: "6", sm: "6" },
          datasets: [
            {
              label: "Today",
              fill: "start",
              borderWidth: 1.5,
              backgroundColor: "rgba(23,198,113,0.1)",
              borderColor: "rgb(23,198,113)",
              data: [1, 2, 3, 3, 3, 4, 4]
            }
          ]
        },
        {
          label: "Comments",
          value: "8,147",
          percentage: "3.8%",
          increase: false,
          decrease: true,
          chartLabels: [null, null, null, null, null, null, null],
          attrs: { md: "4", sm: "6" },
          datasets: [
            {
              label: "Today",
              fill: "start",
              borderWidth: 1.5,
              backgroundColor: "rgba(255,180,0,0.1)",
              borderColor: "rgb(255,180,0)",
              data: [2, 3, 3, 3, 4, 3, 3]
            }
          ]
        },
        {
          label: "New Travelers",
          value: "29",
          percentage: "2.71%",
          increase: false,
          decrease: true,
          chartLabels: [null, null, null, null, null, null, null],
          attrs: { md: "4", sm: "6" },
          datasets: [
            {
              label: "Today",
              fill: "start",
              borderWidth: 1.5,
              backgroundColor: "rgba(255,65,105,0.1)",
              borderColor: "rgb(255,65,105)",
              data: [1, 7, 1, 3, 1, 4, 8]
            }
          ]
        },
        {
          label: "Subscribers",
          value: "17,281",
          percentage: "2.4%",
          increase: false,
          decrease: true,
          chartLabels: [null, null, null, null, null, null, null],
          attrs: { md: "4", sm: "6" },
          datasets: [
            {
              label: "Today",
              fill: "start",
              borderWidth: 1.5,
              backgroundColor: "rgb(0,123,255,0.1)",
              borderColor: "rgb(0,123,255)",
              data: [3, 2, 3, 2, 4, 5, 4]
            }
          ]
        }
      ]
    };
  }

  OnSecurityCheck = async data => {
    var ben;
    var idsecurity = {
      id: data
    };

    ben = JSON.stringify(idsecurity);
    console.log(idsecurity);
    const response = await fetch(
      `https://expressgenetator.herokuapp.com/users/security`,
      {
        method: "POST",
        body: ben,
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json"
        }
      }
    );

    if (response.status === 200) {
      this.setState({
        UserisAdmin: true
      });
    } else {
      console.error("You are not admin of this website");
      this.setState({
        UserisAdmin: false
      });
    }
  };

  HowManyFallowers = async data => {
    let value = this.state.smallStats[0].value;
    let travelsnumber = this.state.smallStats[1].value;
    let Usernumbers = this.state.smallStats[2].value;
    let UserAdmins = this.state.smallStats[3].value;
    let NumberTokensProvided = this.state.smallStats[4].value;
    let vacationsforme;
    try {
      const response = await fetch(
        "https://expressgenetator.herokuapp.com/users/numberoffallowers"
      );
      value = await response.json();
      console.log(value[0]);
      const travelnum = await fetch(
        "https://expressgenetator.herokuapp.com/users/numberoftravels"
      );
      travelsnumber = await travelnum.json();
      console.log(travelsnumber[0]);
      const Usernum = await fetch(
        "https://expressgenetator.herokuapp.com/users/numberofusers"
      );
      Usernumbers = await Usernum.json();
      console.log(Usernumbers[0]);
      const Adminnum = await fetch(
        "https://expressgenetator.herokuapp.com/users/numberofadmin"
      );
      UserAdmins = await Adminnum.json();
      console.log(UserAdmins[0]);
      const Connexionsnum = await fetch(
        "https://expressgenetator.herokuapp.com/users/numberofconnexion"
      );
      NumberTokensProvided = await Connexionsnum.json();
      console.log(NumberTokensProvided[0]);
      const Vacationitself = await fetch(
        "https://expressgenetator.herokuapp.com/users/"
      );
      vacationsforme = await Vacationitself.json();
      console.log("this is vactionforme", vacationsforme);
    } finally {
      this.setState({
        smallStats: [
          {
            label: "Fallowers",
            value: value[0].NumFallowers,
            percentage: "94.7%",
            increase: true,
            chartLabels: [null, null, null, null, null, null, null],
            attrs: { md: "6", sm: "6" },
            datasets: [
              {
                label: "Today",
                fill: "start",
                borderWidth: 1.5,
                backgroundColor: "rgba(0, 184, 216, 0.1)",
                borderColor: "rgb(0, 184, 216)",
                data: [1, 2, 1, 3, 5, 4, 7]
              }
            ]
          },
          {
            label: "Vacations",
            value: travelsnumber[0].NumTravels,
            percentage: "12.4",
            increase: true,
            chartLabels: [null, null, null, null, null, null, null],
            attrs: { md: "6", sm: "6" },
            datasets: [
              {
                label: "Today",
                fill: "start",
                borderWidth: 1.5,
                backgroundColor: "rgba(23,198,113,0.1)",
                borderColor: "rgb(23,198,113)",
                data: [1, 2, 3, 3, 3, 4, 4]
              }
            ]
          },
          {
            label: "Users",
            value: Usernumbers[0].NumUsers,
            percentage: "3.8%",
            increase: false,
            decrease: true,
            chartLabels: [null, null, null, null, null, null, null],
            attrs: { md: "4", sm: "6" },
            datasets: [
              {
                label: "Today",
                fill: "start",
                borderWidth: 1.5,
                backgroundColor: "rgba(255,180,0,0.1)",
                borderColor: "rgb(255,180,0)",
                data: [2, 3, 3, 3, 4, 3, 3]
              }
            ]
          },
          {
            label: "Admins",
            value: UserAdmins[0].NumAdmin,
            percentage: "2.71%",
            increase: false,
            decrease: true,
            chartLabels: [null, null, null, null, null, null, null],
            attrs: { md: "4", sm: "6" },
            datasets: [
              {
                label: "Today",
                fill: "start",
                borderWidth: 1.5,
                backgroundColor: "rgba(255,65,105,0.1)",
                borderColor: "rgb(255,65,105)",
                data: [1, 7, 1, 3, 1, 4, 8]
              }
            ]
          },
          {
            label: "Connexions",
            value: NumberTokensProvided[0].NumberofConnexion,
            percentage: "2.4%",
            increase: false,
            decrease: true,
            chartLabels: [null, null, null, null, null, null, null],
            attrs: { md: "4", sm: "6" },
            datasets: [
              {
                label: "Today",
                fill: "start",
                borderWidth: 1.5,
                backgroundColor: "rgb(0,123,255,0.1)",
                borderColor: "rgb(0,123,255)",
                data: [3, 2, 3, 2, 4, 5, 4]
              }
            ]
          }
        ],
        vacationsforme: [{ title: "ben" }]
      });
      this.setState({
        vacationsforme: vacationsforme.map(data => {
          data.followers = +(data.followers || 0);
          return data;
        })
      });
      console.log("vacationsforme", vacationsforme);
      console.log(this.state);
    }
  };

  async componentDidMount() {
    this.OnSecurityCheck(sessionStorage.getItem("userID"));
    // get number of fallowers
    this.HowManyFallowers();
  }

  render() {
    const { smallStats } = this.state;

    if (this.state.UserisAdmin === false) {
      return <p>you're not allowed to see this page</p>;
    }
    if (
      sessionStorage.getItem("isadmin") === "1" &&
      this.state.UserisAdmin === true
    ) {
      return (
        <Container fluid className="main-content-container px-4">
          {/* Page Header */}
          <Row noGutters className="page-header py-4">
            <PageTitle
              title="My Expedia Overview"
              subtitle="Admin Dashboard"
              className="text-sm-left mb-3"
            />
          </Row>

          {/* Small Stats Blocks */}
          <Row>
            {smallStats.map((stats, idx) => (
              <Col className="col-lg mb-4" key={idx} {...stats.attrs}>
                <SmallStats
                  id={`small-stats-${idx}`}
                  variation="1"
                  chartData={stats.datasets}
                  chartLabels={stats.chartLabels}
                  label={stats.label}
                  value={stats.value}
                  percentage={stats.percentage}
                  increase={stats.increase}
                  decrease={stats.decrease}
                />
              </Col>
            ))}
          </Row>

          <Row>
            {/* Users Overview */}
            <Col lg="8" md="12" sm="12" className="mb-4">
              <div>
                {this.state.vacationsforme && (
                  <VictoryChart
                    domainPadding={10}
                    theme={VictoryTheme.material}
                  >
                    <VictoryAxis
                      tickValues={this.state.vacationsforme.map(({id}) => +id)}
                      tickFormat={this.state.vacationsforme.map(({id}) => `Vacation ${id}`)}
                    />
                    <VictoryAxis
                      dependentAxis
                      tickFormat={x => x}
                    />
                    
                    <VictoryStack colorScale={"warm"}>
                      <VictoryBar
                        data={this.state.vacationsforme}
                        x={"id"}
                        y={"followers"}
                      />
                    </VictoryStack>
                  </VictoryChart>
                )}
              </div>
            </Col>

            {/* Users by Device */}
            <Col lg="4" md="6" sm="12" className="mb-4">
              <UsersByDevice />
            </Col>

            {/* New Draft */}
            <Col lg="4" md="6" sm="12" className="mb-4">
              <NewDraft />
            </Col>

            {this.state.vacationsforme && (
            <Col lg="5" md="12" sm="12" className="mb-4">
              <Discussions vacationforme={this.state.vacationsforme} />
            </Col>
            )}
            {this.state.vacationsforme && (
            <Col lg="3" md="12" sm="12" className="mb-4">
              <TopReferrals vacationforme={this.state.vacationsforme} />
            </Col>
            )}
          </Row>
        </Container>
      );
    }
  }
}

export default BlogOverview;
